import { USE_API_MOCKS } from 'src/env';
import { RESTClientMock, RESTClient } from './client';
import { API_URL } from './apiDictionary';
import { PMTaskDefinition } from '@dynamika-shared/types/pmTaskDefinitions';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchPMTaskDefinitions = async (clinicalTrialId: string) => {
  return api.get<PMTaskDefinition[]>(`${API_URL.pmTaskDefinition}`, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};
export const createPMTaskDefinition = async (
  clinicalTrialId: string,
  data: PMTaskDefinition
) => {
  return api.post(API_URL.pmTaskDefinition, data, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};
export const updatePMTaskDefinition = async (
  taskDefinitionId: string,
  clinicalTrialId: string,
  data: PMTaskDefinition
) => {
  return api.put(
    API_URL.pmTaskDefinitionUpdate.replace(
      ':taskDefinitionId',
      taskDefinitionId
    ),
    data,
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};
export const deletePMTaskDefinition = async (
  taskDefinitionId: string,
  clinicalTrialId: string
) => {
  return api.delete(
    API_URL.pmTaskDefinitionUpdate.replace(
      ':taskDefinitionId',
      taskDefinitionId
    ),
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};
